import { ActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import {
  fetchHelioscopeDesignsListSuccess,
} from 'actions';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function fetchHelioscopeDesignsRequest(action$: Observable<any>) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_HELIOSCOPE_DESIGNS_LIST_REQUEST),
    switchMap(action => ObservableAjax({
      until$: action$.pipe(ofType(ActionTypes.FETCH_HELIOSCOPE_DESIGNS_SUCCESS)),
      onSuccess: fetchHelioscopeDesignsListSuccess,
      onErrorMessage: 'Cannot fetch designs',
      socketName: 'helioscope',
      link: hitApi('get', `api/v1/helioscope/${action.payload.projectId}/`),
    }))
  );
}
